import { render, staticRenderFns } from "./SeasonalRainfallEstimate.vue?vue&type=template&id=2a971f7c&scoped=true"
import script from "./SeasonalRainfallEstimate.vue?vue&type=script&lang=js"
export * from "./SeasonalRainfallEstimate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a971f7c",
  null
  
)

export default component.exports